import type { PromozavrRuntimeController } from './runtime-controller';

type PromozavrRuntimeRendererItem = PromozavrRuntimeController['promoRenderers'][number];

type PromozavrRuntimeRenderers = {
    topLinePromoRenderers: PromozavrRuntimeRendererItem[];
    overlayPromoRenderers: PromozavrRuntimeRendererItem[];
};

export function getPromozavrRuntimeRenderers(
    promoRenderers: PromozavrRuntimeController['promoRenderers']
): PromozavrRuntimeRenderers {
    const topLinePromoNames = new Set<string>();
    const topLinePromoRenderers: PromozavrRuntimeRendererItem[] = [];
    const overlayPromoRenderers: PromozavrRuntimeRendererItem[] = [];

    promoRenderers.forEach((promoRenderer) => {
        const promo = promoRenderer.props.currentPromo;

        if (promo?.format !== 'topline') {
            overlayPromoRenderers.push(promoRenderer);
            return;
        }

        if (topLinePromoNames.has(promo.promo.name)) {
            return;
        }

        topLinePromoNames.add(promo.promo.name);
        topLinePromoRenderers.push(promoRenderer);
    });

    return {
        topLinePromoRenderers,
        overlayPromoRenderers,
    };
}
